import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { NAV_LINKS } from "../data/content";

const Logo = () => (
  <Link to="/" className="flex items-center group" data-testid="logo-link">
    <img
      src="/images/brand/logo_horizontal.png"
      alt="NARA Nutrition"
      className="h-7 md:h-9 w-auto group-hover:opacity-80 transition-opacity"
    />
  </Link>
);

export const Header = () => {
  const { count, setIsOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-100">
      <nav className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <Logo />

        <div className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-royal" : "text-slate-600 hover:text-navy-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={() => navigate("/product")}
            data-testid="nav-shop-now"
            className="hidden sm:inline-flex items-center bg-navy-900 text-white rounded-full px-5 py-2.5 text-sm font-medium hover:bg-navy-800 transition-all duration-300 shadow-lg shadow-slate-900/10 hover:-translate-y-0.5"
          >
            Shop Now
          </button>

          <button
            onClick={() => setIsOpen(true)}
            data-testid="cart-button"
            className="relative p-2.5 rounded-full hover:bg-slate-100 transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-5 h-5 text-navy-900" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-0.5 -right-0.5 w-5 h-5 rounded-full bg-royal text-white text-[10px] font-bold flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>

          <button
            onClick={() => setMobileOpen((o) => !o)}
            className="lg:hidden p-2.5 rounded-full hover:bg-slate-100"
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden border-t border-slate-100 bg-white px-4 py-4 flex flex-col gap-1" data-testid="mobile-menu">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setMobileOpen(false)}
              className="py-2.5 px-2 text-sm font-medium text-slate-700 rounded-lg hover:bg-slate-50"
            >
              {l.label}
            </NavLink>
          ))}
          <button
            onClick={() => { setMobileOpen(false); navigate("/product"); }}
            className="mt-2 bg-navy-900 text-white rounded-full px-5 py-3 text-sm font-medium"
          >
            Shop Now
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
